import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import {
    EDIT_SDK ,
    EDIT_SDK_SUCCESS ,
    EDIT_SDK_FAIL,
} from '../../constants';

const editSDK = (action$, state$) =>
  action$.pipe(
    ofType(EDIT_SDK),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.poiServer}/apps/update/${action.appId}`,
        headers: {
          Authorization: `Bearer ${state$.value.auth.token}`,
          'Content-Type': 'application/json',
        },
        body: action.data,
        responseType: 'json',
        crossDomain: true,
        method: 'POST',
      }).pipe(
        map(response => {
          console.log('edit SDK', response);

          return {
            type: EDIT_SDK_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: EDIT_SDK_FAIL,
            error,
          })
        )
      )
    )
  );

export default editSDK;
